import { Avatar } from '@campgladiator/cgui-core.atoms.avatar'
import { Icon, StandardProps } from '@campgladiator/cgui-core.atoms.icon'
import { Toggle } from '@campgladiator/cgui-core.atoms.toggle'
import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import styles from './preference-tile.module.scss'

type PreferenceTileProps = {
  icon?: StandardProps['name']
  avatar?: string
  label: string
  subLabel?: string
  checked: boolean
  disabled?: boolean
  isSolid?: boolean
  onChange: (value: boolean) => void
}

type PreferenceTileMediaProps = {
  icon?: StandardProps['name']
  avatar?: string
  label: string
}

const PreferenceTileMedia = ({
  icon,
  avatar,
  label,
}: PreferenceTileMediaProps) => {
  if (avatar) {
    return (
      <div className={styles.avatarWrap}>
        <Avatar src={avatar} size="30px" alt={label} />
      </div>
    )
  }

  if (icon) {
    return <Icon.Line name={icon} />
  }

  return null
}

const PreferenceTile = ({
  icon,
  label,
  checked,
  disabled,
  isSolid,
  onChange,
  subLabel,
  avatar,
}: PreferenceTileProps) => (
  <div className={[styles.tile, isSolid ? styles.solid : ''].join(' ')}>
    <div className={styles.tileLeft}>
      <PreferenceTileMedia icon={icon} avatar={avatar} label={label} />

      <div className={styles.tileText}>
        <Paragraph size="default">{label}</Paragraph>

        {subLabel && (
          <Paragraph size="small" weight="book" className={styles.hint}>
            {subLabel}
          </Paragraph>
        )}
      </div>
    </div>

    <Toggle
      id={`toggle-${label}`}
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
    />
  </div>
)

export default PreferenceTile
